import * as React from 'react';
import CreateReportsCore from '../components/AfrCore/CreateReportsCore'
import { LogicalPeriodEnum, TaxonomyTypeEnum } from '../redux/TaxonomyVersionSlice';


const CreateCourtReports939 = () => {
    return (
        <React.Fragment>
            <CreateReportsCore taxonomyType={TaxonomyTypeEnum.COURT_REPORTING_939} reportName="Court Report 939.185, F.S."
                logicalPeriods={[LogicalPeriodEnum.Q_1, LogicalPeriodEnum.Q_2, LogicalPeriodEnum.Q_3, LogicalPeriodEnum.Q_4]} />
        </React.Fragment>
    );
}
export default CreateCourtReports939;
